import { render, staticRenderFns } from "./NotaMedica.vue?vue&type=template&id=03772108"
import script from "./NotaMedica.vue?vue&type=script&lang=js"
export * from "./NotaMedica.vue?vue&type=script&lang=js"
import style0 from "./NotaMedica.vue?vue&type=style&index=0&id=03772108&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports